<div class="card">
	<div class="card-header">
		<h1>Permisos de Usuario</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col form-group">
				<label for="company" class="form-label">Usuario</label>
				<div class="input-group">
					<button class="btn btn-info" [tooltip]="'Crea un usuario'" (click)="creatingUser = true"><i class="fa fa-user-plus"></i></button>
					<app-input-autocomplete (changeStatus)="selectUser($event.filterElement)"
						(inputMethod)="searchUser()" [allBorderRadius]="false" [filterElements]="filterUsers"
						[placeholder]="this.selected?'Busca un usuario':'Selecciona una empresa primero'"
						[ruleToDisabled]="!this.selected" [custom]="true" [inputs]="inputUser">
						<ng-template #itemsTemplate let-filter>
							<!-- This is the content that will be projected -->
							<div items>
								<h5 *ngIf="filter.firstName || filter.lastName" class="text-info"
									style="line-height: normal; margin-bottom: 0;">
									{{filter.firstName}} {{filter.lastName}}</h5>
								<h6 *ngIf="!filter.firstName && !filter.lastName" class="text-muted"
									style="color:lightgray !important; margin-bottom: 0 !important;"><i
										class="fa fa-circle-info"></i>No cuenta con nombre el usuario
								</h6>
								<span class="text-muted" style="color: white !important;">
									<b>{{filter.email}}</b></span>
								<hr style="margin: 0;">
							</div>
						</ng-template>
					</app-input-autocomplete>
				</div>
			</div>
		</div>
		<div class="table-responsive" style="max-height: 500px; overflow: auto;" *ngIf="this.filterUsers.length > 0">
			<table class="table table-hover">
				<caption>Selecciona un usuario haciendo click sobre los datos del mismo</caption>
				<thead>
					<tr class="tr-no-border-top">
						<th>Email</th>
						<th>Nombre</th>
						<th>Apellido</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let user of pagination.filter">
						<tr (click)="selectedUser(user)" [class.checked]="userSelected?.email==user.email">
							<td>{{user.email}}</td>
							<td>{{user.firstName}}</td>
							<td>{{user.lastName}}</td>
							<td>
								<i class="fa fa-trash clickeable text-danger" *ngIf="!loading[user.email]" (click)="deactivate(user)"></i>
								<app-loading-animation *ngIf="loading[user.email]" [color]="'red'" [height]="'1rem'"></app-loading-animation>
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
		<app-pagination-custom [elements]="pagination"></app-pagination-custom>
		<div class="accordion accordion-flush mb-3 mt-3" id="accordion-permissions">
			<div class="accordion-item" *ngFor="let perms of listAllPermissions">
				<h2 class="accordion-header">
					<button class="accordion-button" type="button" data-bs-toggle="collapse"
						[attr.data-bs-target]="'#'+perms.class+'-permissions'" aria-expanded="true"
						[attr.aria-controls]="perms.class+'-permissions'">
						<i class="fa {{perms.icon}}"></i> {{perms.placeholder}}
					</button>
				</h2>
				<div id="{{perms.class}}-permissions" class="accordion-collapse collapse show"
					[attr.data-bs-parent]="'#accordion-permissions'">
					<div class="table-responsive" style="padding: 1em;">
						<table class="table table-striped">
							<thead>
								<tr><!-- 
									<th>ID</th> -->
									<th>Nombre</th>
									<th>Crear</th>
									<th>Editar</th>
									<th>Leer</th>
									<th>Borrar</th>
								</tr>
							</thead>
							<tbody>
								<tr id="{{invPermissions.id}}" *ngFor="let invPermissions of perms.permissions; let i = index"><!-- 
									<td>{{invPermissions.id}}</td> -->
									<td>{{invPermissions.name}}</td>
									<td class="check" (click)="changePermission('create',invPermissions, i, perms.permissions)">
										<a [ngClass]="invPermissions.permission.create?'checked checked2':''"><i
												class="fa fa-plus"></i></a>
									</td>
									<td class="check" (click)="changePermission('update',invPermissions, i, perms.permissions)">
										<a [ngClass]="invPermissions.permission.update?'checked checked2':''"><i
												class="fa fa-edit"></i></a>
									</td>
									<td class="check" (click)="changePermission('read',invPermissions, i, perms.permissions)">
										<a [ngClass]="invPermissions.permission.read?'checked checked2':''"><i
												class="fa fa-eye"></i></a>
									</td>
									<td class="check" (click)="changePermission('delete',invPermissions, i, perms.permissions)">
										<a [ngClass]="invPermissions.permission.delete?'checked checked2':''"><i
												class="fa fa-trash"></i></a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<app-loading-button [object]="buttonSave" [disabled]="!userSelected || !selected"
			(clicked)="savePermissions()"></app-loading-button>
	</div>
</div>
<app-modal-create-user *ngIf="creatingUser" (close)="getUsers(); creatingUser = false;"></app-modal-create-user>